// extracted by mini-css-extract-plugin
export var container = "styles-module--container--4a1a3";
export var content = "styles-module--content--0d9ef";
export var grid = "styles-module--grid--7779a";
export var property = "styles-module--property--0300f";
export var section = "styles-module--section--c6f16";
export var statCard = "styles-module--statCard--88e21";
export var value = "styles-module--value--d259a";
export var visibleCard = "styles-module--visibleCard--dea0a";